/* Recargo de equivalencia 5,2% — truco del céntimo (plan Basic, sin Functions).
   Solo actúa para clientes etiquetados (window.__RECARGO.re = true).
   Añade/ajusta una línea del producto-fee (variante a 0,01€) con cantidad =
   céntimos del 5,2% de la base (mercancía con descuentos [+ porte si se configura]).
   Re-sincroniza tras cualquier cambio del carrito. */
(function () {
  var CFG = window.__RECARGO || {};
  if (!CFG.re || !CFG.feeVariant) return;            // solo clientes de recargo
  var FEE = CFG.feeVariant;
  var RATE = CFG.rate || 0.052;
  var SHIP = CFG.shipping || 0;                      // céntimos de porte (calculado en Liquid por zona/primer pedido)
  var origFetch = window.fetch.bind(window);         // fetch original (nuestras llamadas no disparan el hook)
  var busy = false, pending = false;

  function targetCents(cart) {
    var base = 0;
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === FEE) return;             // excluir la propia línea de recargo
      base += it.line_price;                         // line_price ya lleva descuentos de línea
    });
    if (base <= 0) return 0;                         // sin mercancía, sin recargo
    base += SHIP;                                    // base IVA = mercancía(con dto) + porte (Art. 78 LIVA)
    return Math.round(base * RATE);                  // = cantidad de la variante de 0,01€
  }

  function feeLine(cart) {
    var found = null;
    (cart.items || []).forEach(function (it) { if (it.variant_id === FEE) found = it; });
    return found;
  }

  function add(qty) {
    return origFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: FEE, quantity: qty, properties: { _recargo_equivalencia: '5,2%' } }] }) });
  }
  function change(key, qty) {
    return origFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }) });
  }

  function sync() {
    if (busy) { pending = true; return; }
    busy = true;
    origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var target = targetCents(cart);
        var line = feeLine(cart);
        var cur = line ? line.quantity : 0;
        if (target === cur) return null;
        if (target <= 0 && line) return change(line.key, 0);
        if (!line && target > 0) return add(target);
        if (line) return change(line.key, target);
        return null;
      })
      .then(refreshUI)
      .catch(function () {})
      .then(function () { busy = false; if (pending) { pending = false; sync(); } });
  }

  // Si el tema expone un refresco de carrito, lo llamamos; si no, recargamos en /cart
  function refreshUI() {
    try {
      if (window.location.pathname.indexOf('/cart') === 0) {
        // en la página del carrito, recargar para reflejar el total
        window.location.reload();
      }
    } catch (e) {}
  }

  // Hook: re-sincronizar tras cambios del carrito hechos por el tema (no por nosotros)
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (CART_WRITE.test(url)) p.then(function () { setTimeout(sync, 80); });
    return p;
  };

  // Sincronizar al cargar
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(sync, 250); });
  else setTimeout(sync, 250);
})();
